
import * as olProj from 'ol/proj';

export const DEGREE_SYSTEM =  'EPSG:4326';
export const METER_SYSTEM =  'EPSG:3857';



export const transformDegreeToMercator = (coords: number[]) => {
  return olProj.transform(coords, DEGREE_SYSTEM, METER_SYSTEM);
};



export const transformMercatorToDegree = (coords:number[]) =>{
  return olProj.transform( coords , METER_SYSTEM, DEGREE_SYSTEM);
};


export const transformExtentDegreeToMercator = (bbox:number[]) =>{
  return olProj.transformExtent( bbox, DEGREE_SYSTEM , METER_SYSTEM);
};
export const transformExtentMercatorToDegree = (bbox:number[]) =>{
  return olProj.transformExtent( bbox , METER_SYSTEM, DEGREE_SYSTEM);
};
  
export const transform = (bbox:number[], fromSystem: string, toSystem: string) =>{
  return olProj.transform( bbox, fromSystem , toSystem);
};
 